// @flow

import { reduce } from '../../network/reduce';
import type {
  AssetFeature,
  BranchLevels,
  Filter, GeminiRights, PracticalInfos, ReconciliationStore,
  ShoppingCenter,
} from '../../types/shoppingCenterType';
import type { MediaGallery } from '../../types/keepeekType';
import { initialAppliedFilters } from './shoppingCenterFilter';

export type initialStateType = {
  +baseShoppingCenterList: ShoppingCenter[],
  +filteredShoppingCenterList: ShoppingCenter[],
  +assetFeatureList: AssetFeature[],
  +storeList: string[],
  +shoppingCenterMedia: MediaGallery[],
  +branchLevelList: BranchLevels[],
  +filteredShoppingCenterRequest: string,
  +filteredSecondShoppingCenterRequest: string,
  +shoppingCenterAppliedFilters: Filter[],
  +reconciliationList: ReconciliationStore[],
  +practicalInfos: ?PracticalInfos,
  +userGeminiRights: GeminiRights,
}

const initialState: initialStateType = {
  baseShoppingCenterList: [],
  branchLevelList: [],
  filteredShoppingCenterList: [],
  assetFeatureList: [],
  storeList: [],
  shoppingCenterMedia: [],
  filteredShoppingCenterRequest: '',
  filteredSecondShoppingCenterRequest: '',
  shoppingCenterAppliedFilters: initialAppliedFilters,
  reconciliationList: [],
  practicalInfos: null,
  userGeminiRights: {},
};

export const SAVE_SHOPPING_CENTER_MEDIAS = 'SAVE_SHOPPING_CENTER_MEDIAS';

export const SAVE_SHOPPING_CENTER_LIST = 'SAVE_SHOPPING_CENTER_LIST';

export const FILTER_SHOPPING_CENTER_LIST = 'FILTER_SHOPPING_CENTER_LIST';

export const FILTER_SHOPPING_CENTER_REQUEST = 'FILTER_SHOPPING_CENTER_REQUEST';

export const FILTER_SHOPPING_CENTER_STORE_REQUEST = 'FILTER_SHOPPING_CENTER_STORE_REQUEST';

export const SHOPPING_CENTER_APPLIED_FILTERS = 'SHOPPING_CENTER_APPLIED_FILTERS';

export const SAVE_ASSET_FEATURE_LIST = 'SAVE_ASSET_FEATURE_LIST';

export const SAVE_STORE_LIST = 'SAVE_STORE_LIST';

export const SAVE_BRANCH_LEVEL = 'SAVE_BRANCH_LEVEL';

export const SAVE_PRACTICAL_INFO = 'SAVE_PRACTICAL_INFO';

export const SAVE_RECONCILIATION_LIST = 'SAVE_RECONCILIATION_LIST';

export const SAVE_USER_GEMINI_RIGHTS = 'SAVE_USER_GEMINI_RIGHTS';

const shoppingCenterReducer = reduce(initialState, {
  [SAVE_SHOPPING_CENTER_LIST]: 'baseShoppingCenterList',
  [FILTER_SHOPPING_CENTER_LIST]: 'filteredShoppingCenterList',
  [FILTER_SHOPPING_CENTER_REQUEST]: 'filteredShoppingCenterRequest',
  [FILTER_SHOPPING_CENTER_STORE_REQUEST]: 'filteredSecondShoppingCenterRequest',
  [SHOPPING_CENTER_APPLIED_FILTERS]: 'shoppingCenterAppliedFilters',
  [SAVE_ASSET_FEATURE_LIST]: 'assetFeatureList',
  [SAVE_STORE_LIST]: 'storeList',
  [SAVE_SHOPPING_CENTER_MEDIAS]: 'shoppingCenterMedia',
  [SAVE_BRANCH_LEVEL]: 'branchLevelList',
  [SAVE_RECONCILIATION_LIST]: 'reconciliationList',
  [SAVE_PRACTICAL_INFO]: 'practicalInfos',
  [SAVE_USER_GEMINI_RIGHTS]: 'userGeminiRights',

});

export default shoppingCenterReducer;
